
 
import { axiosRequest, AxiosRequestOptions } from "../api";
import  config from '../../config';


import {StartCounselorCallInput, StartCounselorCallOutput, ReserveAppointmentInput, ReserveAppointmentOutput, DiscardCounselorCallInput, DiscardCounselorCallOutput, CallFutureAppointmentInput, CallFutureAppointmentOutput, UploadCounselingFormFieldFileOutput, PersistFilledCounselingFormInput, PersistFilledCounselingFormOutput, PackageCounselorCandidatesInput, PackageCounselorCandidatesOutput, ExtendingCounselorCandidatesInput, ExtendingCounselorCandidatesOutput, CounselingFormsOutput, CounselingFormFields200Results, CounselorCallDetailsOutput, MyAppointmentsOutput, MyCounselorsOutput, MyCounselorProfileOutput, ReservingAppointmentOutput, CancelAppointmentInput, CancelAppointmentOutput, CompleteAppointmentInput, CompleteAppointmentOutput, StartAppointmentCallInput, StartAppointmentCallOutput, DiscardAppointmentCallInput, DiscardAppointmentCallOutput, ImpersonateApplicantInput, ImpersonateApplicantOutput, GoOnlineInput, GoOnlineOutput, GoOfflineInput, GoOfflineOutput, CallableAppointmentOutput, AppointmentDetailsOutput, ConsulteeApplicantsOutput, GoingOnlineOptionsOutput, FollowCounselorInput, FollowCounselorOutput, UnFollowCounselorInput, UnFollowCounselorOutput, CounselorsHallOutputOriginalType, CounselorHallLandingsOutputOriginalType, CounselorsOutput, CounselorsQueryOutput, CounselorsCategoriesOutput, CounselorsCategoryOptionsOutput, CounselorsFilterOutput, CounselorOutput, CounselorBlogPostsOutput, CounselorPackagesOutput, ClearFullTextCacheInput, ClearFullTextCacheOutput } from '../../types/consultancy';

export default  {
 
    
    startCounselorCall(data : StartCounselorCallInput, options?: AxiosRequestOptions) { 
        return axiosRequest< StartCounselorCallOutput, StartCounselorCallInput >("POST",`${config.apiUrl.consultancy}/ApplicantCommand/StartCounselorCall`,data, options);
    },
 
    
    reserveAppointment(data : ReserveAppointmentInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ReserveAppointmentOutput, ReserveAppointmentInput >("POST",`${config.apiUrl.consultancy}/ApplicantCommand/ReserveAppointment`,data, options);
    },
 
    
    discardCounselorCall(data : DiscardCounselorCallInput, options?: AxiosRequestOptions) { 
        return axiosRequest< DiscardCounselorCallOutput, DiscardCounselorCallInput >("POST",`${config.apiUrl.consultancy}/ApplicantCommand/DiscardCounselorCall`,data, options);
    },
 
    
    callFutureAppointment(data : CallFutureAppointmentInput, options?: AxiosRequestOptions) { 
        return axiosRequest< CallFutureAppointmentOutput, CallFutureAppointmentInput >("POST",`${config.apiUrl.consultancy}/ApplicantCommand/CallFutureAppointment`,data, options);
    },
 
    
    uploadCounselingFormFieldFile(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest< UploadCounselingFormFieldFileOutput >("POST",`${config.apiUrl.consultancy}/ApplicantCommand/UploadCounselingFormFieldFile`,data, options);
    },
 
    
    persistFilledCounselingForm(data : PersistFilledCounselingFormInput, options?: AxiosRequestOptions) { 
        return axiosRequest< PersistFilledCounselingFormOutput, PersistFilledCounselingFormInput >("POST",`${config.apiUrl.consultancy}/ApplicantCommand/PersistFilledCounselingForm`,data, options);
    },
 
    
    packageCounselorCandidates(data : PackageCounselorCandidatesInput, options?: AxiosRequestOptions) { 
        return axiosRequest< PackageCounselorCandidatesOutput, PackageCounselorCandidatesInput >("POST",`${config.apiUrl.consultancy}/ApplicantCommand/PackageCounselorCandidates`,data, options);
    },
 
    
    extendingCounselorCandidates(data : ExtendingCounselorCandidatesInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ExtendingCounselorCandidatesOutput, ExtendingCounselorCandidatesInput >("POST",`${config.apiUrl.consultancy}/ApplicantCommand/ExtendingCounselorCandidates`,data, options);
    },
 
    
    counselingForms(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselingFormsOutput >("GET",`${config.apiUrl.consultancy}/ApplicantQuery/CounselingForms${queryParams || ""}`,undefined, options);
    },
 
    
    counselingFormFields(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselingFormFields200Results >("GET",`${config.apiUrl.consultancy}/ApplicantQuery/CounselingFormFields${queryParams || ""}`,undefined, options);
    },
 
    
    counselorCallDetails(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorCallDetailsOutput >("GET",`${config.apiUrl.consultancy}/ApplicantQuery/CounselorCallDetails${queryParams || ""}`,undefined, options);
    },
 
    
    myAppointments(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< MyAppointmentsOutput >("GET",`${config.apiUrl.consultancy}/ApplicantQuery/MyAppointments${queryParams || ""}`,undefined, options);
    },
 
    
    myCounselors(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< MyCounselorsOutput >("GET",`${config.apiUrl.consultancy}/ApplicantQuery/MyCounselors${queryParams || ""}`,undefined, options);
    },
 
    
    myCounselorProfile(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< MyCounselorProfileOutput >("GET",`${config.apiUrl.consultancy}/ApplicantQuery/MyCounselorProfile${queryParams || ""}`,undefined, options);
    },
 
    
    reservingAppointment(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ReservingAppointmentOutput >("GET",`${config.apiUrl.consultancy}/ApplicantQuery/ReservingAppointment${queryParams || ""}`,undefined, options);
    },
 
    
    cancelAppointment(data : CancelAppointmentInput, options?: AxiosRequestOptions) { 
        return axiosRequest< CancelAppointmentOutput, CancelAppointmentInput >("POST",`${config.apiUrl.consultancy}/ConsultancyCommand/CancelAppointment`,data, options);
    },
 
    
    completeAppointment(data : CompleteAppointmentInput, options?: AxiosRequestOptions) { 
        return axiosRequest< CompleteAppointmentOutput, CompleteAppointmentInput >("POST",`${config.apiUrl.consultancy}/ConsultancyCommand/CompleteAppointment`,data, options);
    },
 
    
    startAppointmentCall(data : StartAppointmentCallInput, options?: AxiosRequestOptions) { 
        return axiosRequest< StartAppointmentCallOutput, StartAppointmentCallInput >("POST",`${config.apiUrl.consultancy}/ConsultancyCommand/StartAppointmentCall`,data, options);
    },
 
    
    discardAppointmentCall(data : DiscardAppointmentCallInput, options?: AxiosRequestOptions) { 
        return axiosRequest< DiscardAppointmentCallOutput, DiscardAppointmentCallInput >("POST",`${config.apiUrl.consultancy}/ConsultancyCommand/DiscardAppointmentCall`,data, options);
    },
 
    
    impersonateApplicant(data : ImpersonateApplicantInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ImpersonateApplicantOutput, ImpersonateApplicantInput >("POST",`${config.apiUrl.consultancy}/ConsultancyCommand/ImpersonateApplicant`,data, options);
    },
 
    
    goOnline(data : GoOnlineInput, options?: AxiosRequestOptions) { 
        return axiosRequest< GoOnlineOutput, GoOnlineInput >("POST",`${config.apiUrl.consultancy}/ConsultancyCommand/GoOnline`,data, options);
    },
 
    
    goOffline(data : GoOfflineInput, options?: AxiosRequestOptions) { 
        return axiosRequest< GoOfflineOutput, GoOfflineInput >("POST",`${config.apiUrl.consultancy}/ConsultancyCommand/GoOffline`,data, options);
    },
 
    
    callableAppointment(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CallableAppointmentOutput >("GET",`${config.apiUrl.consultancy}/ConsultancyQuery/CallableAppointment${queryParams || ""}`,undefined, options);
    },
 
    
    appointmentDetails(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< AppointmentDetailsOutput >("GET",`${config.apiUrl.consultancy}/ConsultancyQuery/AppointmentDetails${queryParams || ""}`,undefined, options);
    },
 
    
    consulteeApplicants(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< ConsulteeApplicantsOutput >("GET",`${config.apiUrl.consultancy}/ConsultancyQuery/ConsulteeApplicants${queryParams || ""}`,undefined, options);
    },
 
    
    goingOnlineOptions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< GoingOnlineOptionsOutput >("GET",`${config.apiUrl.consultancy}/ConsultancyQuery/GoingOnlineOptions${queryParams || ""}`,undefined, options);
    },
 
    
    followCounselor(data : FollowCounselorInput, options?: AxiosRequestOptions) { 
        return axiosRequest< FollowCounselorOutput, FollowCounselorInput >("POST",`${config.apiUrl.consultancy}/CounselorsCommand/FollowCounselor`,data, options);
    },
 
    
    unFollowCounselor(data : UnFollowCounselorInput, options?: AxiosRequestOptions) { 
        return axiosRequest< UnFollowCounselorOutput, UnFollowCounselorInput >("POST",`${config.apiUrl.consultancy}/CounselorsCommand/UnFollowCounselor`,data, options);
    },
 
    
    hall(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorsHallOutputOriginalType >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/Hall${queryParams || ""}`,undefined, options);
    },
 
    
    landing(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorHallLandingsOutputOriginalType >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/Landing${queryParams || ""}`,undefined, options);
    },
 
    
    counselors(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorsOutput >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/Counselors${queryParams || ""}`,undefined, options);
    },
 
    
    counselorsQuery(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorsQueryOutput >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/CounselorsQuery${queryParams || ""}`,undefined, options);
    },
 
    
    counselorsCategories(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorsCategoriesOutput >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/CounselorsCategories${queryParams || ""}`,undefined, options);
    },
 
    
    counselorsCategoryOptions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorsCategoryOptionsOutput >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/CounselorsCategoryOptions${queryParams || ""}`,undefined, options);
    },
 
    
    counselorsFilter(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorsFilterOutput >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/CounselorsFilter${queryParams || ""}`,undefined, options);
    },
 
    
    counselor(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorOutput >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/Counselor${queryParams || ""}`,undefined, options);
    },
 
    
    counselorBlogPosts(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorBlogPostsOutput >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/CounselorBlogPosts${queryParams || ""}`,undefined, options);
    },
 
    
    counselorPackages(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest< CounselorPackagesOutput >("GET",`${config.apiUrl.consultancy}/CounselorsQuery/CounselorPackages${queryParams || ""}`,undefined, options);
    },
 
    
    clearFullTextCache(data : ClearFullTextCacheInput, options?: AxiosRequestOptions) { 
        return axiosRequest< ClearFullTextCacheOutput, ClearFullTextCacheInput >("POST",`${config.apiUrl.consultancy}/ManagementCommand/ClearFullTextCache`,data, options);
    },
 
    
    cachedClientVersions(queryParams : string, options?: AxiosRequestOptions) { 
        return axiosRequest  ("GET",`${config.apiUrl.consultancy}/ManagerCore/CachedClientVersions${queryParams || ""}`,undefined, options);
    },
 
    
    invalidateClientVersionsCache(data : any, options?: AxiosRequestOptions) { 
        return axiosRequest  ("POST",`${config.apiUrl.consultancy}/ManagerCore/InvalidateClientVersionsCache`,data, options);
    },

};